module.exports = __webpack_public_path__ + "img/desktop_items_icon.534f3787.png";